import {
	ImageService,
	PortfolioService,
	ContentService,
	ListingModalService,
	ObserverService,
	LocalStorageService
} from '@DavisDigital/davisdigitalfrontend.module';

import { ContentModuleTypes, EVENTS, FolderTypes } from '@DavisDigital/interfaces';
import * as Shepherd from '../../../../../org/Hibachi/client/lib/shepherd.js/dist/js/shepherd.min.js';

class PortfolioEditorController {
	
	public contentModuleDraggable: boolean;
	public displaySideMenu: boolean = false; 
	public hasLoaded: boolean = false;
	public isLoading: boolean = false;
	public isSaving: boolean = false;
	public shepherdToggle: boolean = true;
	
	public nextPortfolioIndex = 1;
	
	public slatwall: any;

	public permissions;
	public portfolioPage;
	public portfolio;
	public portfolioPageDraggable: boolean;
	public portfolioNameEditMode:boolean = false;
	public portfolioPageNameEditMode:boolean = false;
	public portfolioPageToDelete:any;
	public portfolioPageToDeleteIndex:number;
	public splitExampleText:string = `
		<p>
			This is the default Split Layout module. Click here to replace this text with your portfolio content. 
			You can copy & paste from another or document or type directly into the box. You can change the default 
			image by clicking the image icon at the bottom left of the default image.
		</p>
	`;
	public currentPortfolioPage: string;

	
	public viewType: string;
	public hideBackButton:boolean = false;
	public davisAccountType:string = "";
	public defaultPageTitle = "Welcome";
	public readonly icons = {
		'cmtButton': 'power-off',
		'cmtButtonFile': 'power-off',
		'cmtButtonLink': 'power-off',
		'cmtButtonSubtype': 'power-off',
		'cmtComments': 'comments',
		'cmtContact': 'address-card',
		'cmtEmbed': 'file-import',
		'cmtForm': 'address-card',
		'cmtGallery': 'images',
		'cmtImageGalleryGrid': 'images',
		'cmtImageGallerySingle': 'images',
		'cmtImageGallerySlideShow': 'images',
		'cmtImageGallerySubtype': 'images',
		'cmtSplit': 'columns',
		'cmtText': 'paragraph',
		'cmtVideo': 'play-circle'
	};
	public siblingsLoading = false;
	public siblingPortfolios = [];
	
	// @ngInject
	constructor(
		private ModalService,
		private $attrs: ng.IAttributes,
		private $anchorScroll: ng.IAnchorScrollService,
		private $filter: ng.IFilterService,
		private $location: ng.ILocationService,
		private $rootScope: ng.IRootScopeService,
		private $timeout:   ng.ITimeoutService,
		private $window: ng.IWindowService,
		private apiService,
		private contentService: ContentService,
		private imageService: ImageService,
		private listingModalService : ListingModalService,
		private observerService: ObserverService,
		public alertService,
		private portfolioService: PortfolioService,
		private localStorageService: LocalStorageService

	) {}

	public $onInit = () => {
		
		this.$anchorScroll.yOffset = 200;
		
		this.davisAccountType = this.$attrs.davisAccountType;
		
		var portfolioID = this.$location.search().portfolioID;
		var portfolioPageID = this.$location.search().portfolioPageID;
		
		var publicPath = this.$location.path().substr(1); //get public URL from path & remove forward slash
		
		this.viewType = this.$location.search().view;
		
		if(this.viewType == null){
			this.setViewType('edit');
		}
		
		if ( portfolioPageID != null && portfolioPageID.length){
			
			this.registerEvents(portfolioPageID);

			this.isLoading = true;

			this.portfolioService.getPortfolioPageDetails(portfolioPageID)
			.then( (response) => {
				this.isLoading = false;
				this.hasLoaded = true;
				this.permissions = this.apiService.getPermissions();
				this.setPortfolioPage(response.data?.portfolioPage);
				
				if(!response.data?.portfolioPage?.portfolio?.accountLoggedIn &&
				publicPath?.toLowerCase() != response.data?.portfolioPage?.portfolio?.urlTitle?.toLowerCase()){
					this.observerService.notify('Unauthorized');
					var message = {
						msg:'You have been logged out',
						type:'error'
					};
					this.alertService.addAlert(message);
					this.$window.location.href = '/my-profile';
				}
				
				if(publicPath == 'portfolio-editor/' && this.viewType === 'edit'){
					this.initShepherdPortfolioEdit();
				}
			});
			this.getPortfoliosInFolder();
			
		} else if( portfolioID?.length || ( 
			publicPath != '' && 
			publicPath != 'portfolios' && 
			publicPath != 'portfolio-editor/' ) 
		){
		
			this.registerEvents();
			
			this.isLoading = true; 
			
			this.portfolioService.getPortfolioDetails(portfolioID, publicPath)
			.then ( (response) =>{
				this.setPortfolioPage(response.data);
				this.permissions = this.apiService.getPermissions();
				this.isLoading = false; 
				this.hasLoaded = true;
				
				this.observerService.attach(this.setPortfolioPage,  EVENTS.SET_PORTFOLIO_PAGE);
				
				if( publicPath != '' && 
					publicPath != 'portfolios' &&
					publicPath != 'portfolio-editor/'
				){
					this.setViewType('present');
					if(publicPath != 'portfolio/') {
						this.hideBackButton = true;
					}
					
				}
				if(!response.data?.portfolio?.accountLoggedIn &&
				publicPath.toLowerCase() != response.data?.portfolio?.urlTitle.toLowerCase()){
					this.observerService.notify('Unauthorized');
					var message = {
						msg:'You have been logged out',
						type:'error'
					};
					this.alertService.addAlert(message);
					this.$window.location.href = '/my-profile';
				} 
				
				if(publicPath == 'portfolio-editor/' && this.viewType === 'edit'){
					this.initShepherdPortfolioEdit();
				}
			});
		
		} else {
			
			this.registerEvents();
			
			this.portfolioPage = {
				portfolio:{}
			};
			
			this.portfolioPage.contentModules = [];
			
			this.portfolioPage.contentModules.push(
				this.contentService.newContentModule(ContentModuleTypes.SPLIT, 1, this.splitExampleText),
			);
			
			this.apiService.getPermissionsPromise().then(
				(permissions)=>{
					this.permissions = permissions;
				}
			);
			
			this.observerService.attach(this.setPortfolioPage,  EVENTS.SET_PORTFOLIO_PAGE);

			this.hasLoaded = true;
		}
		
		if(this.viewType == null){
			this.setViewType('edit');
		}
		
		this.portfolioPageDraggable = this.viewType === 'edit';
		this.contentModuleDraggable = this.portfolioPageDraggable;
		
		if(publicPath == 'portfolio-editor/' && this.viewType === 'edit' && this.hasLoaded){
			this.initShepherdPortfolioEdit();
		}
	};
	
	public $onDestroy = () =>{
		
	}

	public registerEvents = (portfolioPageID?) => {
		
		if(portfolioPageID?.length === 32){	
			this.observerService.attach(this.addContentModule, EVENTS.ADD_CONTENT, portfolioPageID);
			this.observerService.attach(this.updateContentModule, EVENTS.UPDATE_CONTENT, portfolioPageID);
			this.observerService.attach(this.deleteContentModule, EVENTS.DELETE_CONTENT, portfolioPageID);
			this.observerService.attach(this.savePortfolioPage, EVENTS.SAVE_PORTFOLIO_PAGE, portfolioPageID);
			this.observerService.attach(this.setPortfolioPage, EVENTS.SET_PORTFOLIO_PAGE, portfolioPageID);
			this.observerService.attach(this.setPortfolioPageErrors, EVENTS.SET_PORTFOLIO_PAGE_ERRORS,portfolioPageID);
		} else {
			this.observerService.attach(this.addContentModule, EVENTS.ADD_CONTENT);
			this.observerService.attach(this.updateContentModule, EVENTS.UPDATE_CONTENT);
			this.observerService.attach(this.deleteContentModule, EVENTS.DELETE_CONTENT);
			this.observerService.attach(this.savePortfolioPage, EVENTS.SAVE_PORTFOLIO_PAGE);
			this.observerService.attach(this.setPortfolioPage, EVENTS.SET_PORTFOLIO_PAGE);
			this.observerService.attach(this.setPortfolioPageErrors, EVENTS.SET_PORTFOLIO_PAGE_ERRORS);
		}
		
		this.observerService.attach(this.updateSortOrder, 'contentModuleSortOrderUpdated');
		this.observerService.attach(this.updatePortfolioPageSortOrder, 'portfolioPageSortOrderUpdated');
	};
	
	public deregisterEvents = (portfolioPageID?) =>{
		if(portfolioPageID){
			this.observerService.detachById(portfolioPageID);
		} else {
			this.observerService.detachByEvent(EVENTS.ADD_CONTENT)
			this.observerService.detachByEvent(EVENTS.UPDATE_CONTENT)
			this.observerService.detachByEvent(EVENTS.DELETE_CONTENT)
			this.observerService.detachByEvent(EVENTS.SAVE_PORTFOLIO_PAGE)
			this.observerService.detachByEvent(EVENTS.SET_PORTFOLIO_PAGE)
		}
		
		this.observerService.detachByEvent('contentModuleSortOrderUpdated');
		this.observerService.detachByEvent('portfolioPageSortOrderUpdated');
	}
	
	public reRegisterEvents = (args) =>{
		if(args.portfolioPageID){
			this.deregisterEvents();
			this.registerEvents(args.portfolioPageID);
		}
	}
	
	public addPortfolioPage = () =>{
		this.ModalService.showModal({
			component: 'addPortfolioPageModal',
			bodyClass: 'angular-modal-service-active',
			bindings: {
				portfolio: this.portfolio,
			},
			preClose: (modal) => {
				modal.element.modal('hide');
			},
		}).then((modal) => {
			//it's a bootstrap element, use 'modal' to show it
			modal.element.modal('show');
			modal.close.then((result) => {});
			//re-register scrollbar
			$(".mCustomScrollbar").mCustomScrollbar();
		});
	}

	public addContentModule = (contentModule) => {
		
		if(this.portfolioPage.contentModules == null){
			this.portfolioPage.contentModules = [contentModule];
		}
		
		if(contentModule.contentModuleType_systemCode === ContentModuleTypes.EMBEDDED && !contentModule.contentModuleCreated){
			contentModule.contentModuleCreated=true;
		}else{
			contentModule.contentModuleCreated=false;
		}
		
		this.updateSortOrder(this.portfolioPage.contentModules, contentModule);

		this.portfolioPage.contentModules.splice(contentModule.sortOrder, 0, contentModule);

		if (
			contentModule.contentModuleType_systemCode === ContentModuleTypes.FORM ||
			contentModule.contentModuleType_systemCode === ContentModuleTypes.VIDEO ||
			contentModule.contentModuleType_systemCode === ContentModuleTypes.IMAGE ||
			contentModule.contentModuleType_systemCode === ContentModuleTypes.BUTTON ||
			(contentModule.contentModuleType_systemCode === ContentModuleTypes.EMBEDDED && contentModule.contentModuleCreated)
		) {
			this.savePortfolioPage({
				contentModule: contentModule,
			});
		}
		
		this.portfolioPage.contentModules = this.$filter('orderBy')(this.portfolioPage.contentModules, '+sortOrder');
	};
	
	public backToFolder = () =>{ 
		this.$window.location.href = '/' + 'portfolios?folderID=' + this.portfolio.folder.folderID;
	} 
	
	public goToPortfolioPage = (portfolioPage) =>{
		
		if(portfolioPage.portfolioPageID == null) return;
		
		this.isLoading = true;

		return this.portfolioService.getPortfolioPageDetails(portfolioPage.portfolioPageID)
		.then( (response) => {
			this.isLoading = false;
			this.hasLoaded = true;
			this.setPortfolioPage(response.data.portfolioPage);
		});
	}
	
	public nextPortfolio = () =>{
		if(!this.portfolio.folder.portfolios[this.nextPortfolioIndex]) return;
		
		this.$location.search('portfolioPageID', null);
		this.$location.search('portfolioID', this.portfolio.folder.portfolios[this.nextPortfolioIndex].portfolioID);
		this.$onDestroy();
		this.$onInit();
		this.nextPortfolioIndex++;
	}
	
	public previousPortfolio = () =>{
		if(!this.portfolio.folder.portfolios[this.nextPortfolioIndex - 2]) return;
		
		this.$location.search('portfolioPageID', null);
		this.$location.search('portfolioID', this.portfolio.folder.portfolios[this.nextPortfolioIndex-2].portfolioID);
		this.$onDestroy();
		this.$onInit();
		this.nextPortfolioIndex--;
	}

	public updateContentModule = (contentModule, save=true) => {
		for (var i = 0; i < this.portfolioPage.contentModules.length; i++) {
			if (this.portfolioPage.contentModules[i].contentModuleID === contentModule.contentModuleID) {
				this.portfolioPage.contentModules[i] = contentModule;

				if(save){
					this.savePortfolioPage({
						contentModule: contentModule,
					});
				}
				break;
			}
		}
	};
	
	public updatePortfolioPageSortOrder = (portfolioPages, portfolioPage) =>{
		
		var portfolioPagesToUpdate = [];
		var seenIndices = [];
		
		for( var i=0; i <= this.portfolio.portfolioPages.length; i++){
			
			if( this.portfolio.portfolioPages[i] == null ) continue;
			
			if( !portfolioPage ){
				
				this.portfolio.portfolioPages[i].sortOrder = i;
				
				portfolioPagesToUpdate.push( this.portfolio.portfolioPages[i] );
				
			} else if ( 
				this.portfolio.portfolioPages[i].sortOrder >= portfolioPage.sortOrder
			){
			
				this.portfolio.portfolioPages[i].sortOrder++;
				portfolioPagesToUpdate.push( this.portfolio.portfolioPages[i] );
			
			}
			
			while(seenIndices.indexOf(this.portfolio.portfolioPages[i].sortOrder) > -1){
				this.portfolio.portfolioPages[i].sortOrder++;
			}
			
			if ( this.portfolioPage.portfolioPageID === this.portfolio.portfolioPages[i].portfolioPageID ) {
				this.portfolioPage.sortOrder = this.portfolio.portfolioPages[i].sortOrder;
			}
			
			seenIndices.push(this.portfolio.portfolioPages[i].sortOrder);
		}
		
		this.contentService.updateSortOrder(portfolioPagesToUpdate);
		
		this.portfolio.portfolioPages = this.$filter('orderBy')(this.portfolio.portfolioPages, '+sortOrder')
		
		this.portfolioService.updatePortfolioPageSortOrder(this.portfolio.portfolioPages)
		.then(
			(response) => {
				//do nothing assume success
			}
		);
	}

	public updateSortOrder = (contentModules, contentModule) => {
		var contentModulesToUpdate = [];
		var seenIndices = [];

		for (var i = 0; i <= contentModules.length; i++) {
			
			if (contentModules[i] == null) continue;

			if( !contentModule ){
				
				contentModules[i].sortOrder = i;
				
				contentModulesToUpdate.push( contentModules[i] );
				
			} else if (contentModules[i].sortOrder >= contentModule.sortOrder) {
				
				contentModules[i].sortOrder++;
				
				contentModulesToUpdate.push( contentModules[i] );
			}

			while (seenIndices.indexOf(contentModules[i].sortOrder) > -1) {
				contentModules[i].sortOrder++;
			}

			seenIndices.push( contentModules[i].sortOrder );
		}

		this.contentService.updateSortOrder(contentModulesToUpdate).then(
			(response:any) =>{

				if( response.data.portfolioPageID?.length === 32 &&
					response.data.portfolioPageID === this.portfolioPage.portfolioPageID
				){
					this.portfolioPage.contentModules = this.$filter('orderBy')(contentModules, '+sortOrder');
				}
			}
		);
	};

	public deleteContentModule = (args) => {
		if (args.contentModule.contentModuleID == null || args.contentModule.contentModuleID.length !== 32) {
			this.portfolioPage.contentModules.splice(args.position, 1);
		} else {
			this.contentService.deleteContentModule(args.contentModule).then((result) => {
				if (result.data.success) {
					return this.removeContentModule(args.contentModule.contentModuleID);
				}

				if (result.data.message === 'No content module with ID found') {
					return this.portfolioPage.contentModules.splice(args.position, 1);
				}
			});
		}
	};
	
	public executeDeletePortfolioPage = (execute=true) =>{
		if(!execute) return;
		
		if(this.portfolioPageToDelete == null || this.portfolioPageToDeleteIndex == null) return;
		
		this.portfolioService.deletePortfolioPage(this.portfolioPageToDelete).then((response)=>{
			
			if(response.successfulActions){
				
				this.portfolioPage.portfolio.portfolioPages.splice(this.portfolioPageToDeleteIndex, 1);
				
				if(this.portfolioPage.portfolioPageID === this.portfolioPageToDelete.portfolioPageID){
					if(this.portfolioPageToDeleteIndex > 0){
						this.goToPortfolioPage(	this.portfolioPage.portfolio.portfolioPages[this.portfolioPageToDeleteIndex - 1] )	
					} else {
						this.goToPortfolioPage(	this.portfolioPage.portfolio.portfolioPages[this.portfolioPageToDeleteIndex + 1] )	
					}
				}
			}
		
		}).finally(()=>{
			this.portfolioPageToDelete = null;
			this.portfolioPageToDeleteIndex = null;
		});
	}
	
	public deletePortfolioPage = (portfolioPage, portfolioPageIndex) =>{
		
		if(this.portfolio.portfolioPages.length === 1) return;
		
		this.portfolioPageToDelete = portfolioPage;
		this.portfolioPageToDeleteIndex = portfolioPageIndex;
		
		this.ModalService.showModal({
			component: 'confirmDeleteModal',
			bodyClass: 'angular-modal-service-active',
			bindings: {
				title:'The portfolio page will be permentently deleted.',
				type:'Portfolio Page',
				closeCallback: this.executeDeletePortfolioPage
			},
			preClose: (modal) => {
				modal.element.modal('hide');
			},
		}).then((modal) => {
			//it's a bootstrap element, use 'modal' to show it
			modal.element.modal('show');
			modal.close.then((result) => {});
		});
	}
	
	public editContentModuleTitle = (contentModule,portfolioPage) => {
	
		if(!contentModule.title?.trim().length){
			contentModule.title = contentModule.contentModuleType_typeName;
		}
		
		contentModule.editingTitle = !contentModule.editingTitle;
		
		this.contentModuleDraggable = !contentModule.editingTitle;
		this.portfolioPageDraggable = !contentModule.editingTitle;
		
		if(!contentModule.editingTitle){
			this.contentService.saveContentModule(contentModule).then(()=>{
               	this.updateContentModule(contentModule,false);
            });
		
		}
	}
	
	public editPortfolioPageTitle = ( portfolioPage ) =>{
		portfolioPage.editingTitle = !portfolioPage.editingTitle;
		
		this.contentModuleDraggable = !portfolioPage.editingTitle;
		this.portfolioPageDraggable = !portfolioPage.editingTitle;
		
		if(!portfolioPage.editingTitle){
			this.portfolioService.savePortfolioPage(portfolioPage, {}).then((response)=>{
				//do nothing we could notify saving has succeeded
			})
		}
	}

	private removeContentModule = (contentModuleID) => {
		for (var i = 0; i < this.portfolioPage.contentModules.length; i++) {
			if (contentModuleID === this.portfolioPage.contentModules[i].contentModuleID) {
				this.portfolioPage.contentModules.splice(i, 1);
				break;
			}
		}
	};
	
	public savePortfolio = (args?) =>{
		if( !this.portfolioPage.portfolio.portfolioID ){
			this.launchSaveAsModal()
			return;
		}
		
		this.isSaving = true;
		
		this.portfolioService.savePortfolio(this.portfolio).then(
			(response)=>{
				this.isSaving = false;
			}
		);
	}

	public savePortfolioPage = (args?) => {
		
		if ( !this.portfolioPage.portfolioPageID ||
			 !this.portfolioPage.portfolio.portfolioID
		) {
			this.launchSaveAsModal()
			return;
		}

		this.isSaving = true;

		this.portfolioService.savePortfolioPage(this.portfolioPage, args).then((response) => {
			if (response == null) {
				console.warn('Could not save portfolio page, recieved empty response.');
				return;
			}

			this.isSaving = false;
			this.observerService.notify(EVENTS.SET_PORTFOLIO_PAGE, response.data.portfolioPage);
			

			
		});
	};

	public scrollToContentModule = ( contentModule:any, portfolioPage:any ) =>{
		
		if(portfolioPage.portfolioPageID != this.portfolioPage.portfolioPageID){
		
			return this.goToPortfolioPage(portfolioPage).finally(()=>{
				this.displaySideMenu = false;
			
				var contentModuleID = 'cm' + contentModule.contentModuleID;
				
				this.$anchorScroll(contentModuleID);
			});
		
		}
		
		this.displaySideMenu = false;
			
		var contentModuleID = 'cm' + contentModule.contentModuleID;
		
		this.$timeout(() => {
			var element = document.getElementById(contentModuleID);
			if (element) {
				var headerOffset = 200;
				var elementPosition = element.getBoundingClientRect().top;
				var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
				
				window.scrollTo({
					top: offsetPosition,
					behavior: 'smooth'
				});
			}
		}, 150);
	}
	
	public setPortfolioPageErrors = (portfolioPageErrors) =>{
		this.errors = portfolioPageErrors;
	}

	public setPortfolioPage = (portfolioPage) => {
		
		if ( this.$location.search().portfolioPageID == null || 
			 this.$location.search().portfolioPageID != portfolioPage.portfolioPageID
		){
			this.$location.search('portfolioPageID', portfolioPage.portfolioPageID);
			this.registerEvents(portfolioPage.portfolioPageID);
		}
		this.currentPortfolioPage = portfolioPage.portfolioPageID

		if( portfolioPage.portfolio ){
			this.portfolio = portfolioPage.portfolio;
			this.getPortfoliosInFolder();
		} else {
			this.portfolio = {};
		}

		if (portfolioPage.imageMap) {
			this.imageService.setImageMap(portfolioPage.imageMap).then((imageMap)=>{
				this.$timeout(()=>{
					this.portfolioPage = portfolioPage;
					this.handleNewPortfolioPageExpand();
				});
			}).finally(()=>{
				//we need to update the content modules so that images will load after being uploaded
				this.observerService.notify(EVENTS.UPDATE_CONTENT_MODULES);
			});
		} else {
			this.portfolioPage = portfolioPage
			
			//we need to update the content modules so that images will load after being uploaded
			this.observerService.notify(EVENTS.UPDATE_CONTENT_MODULES);
			this.handleNewPortfolioPageExpand();
		}
	};
	
	private handleNewPortfolioPageExpand = () => {
		if (this.portfolio && this.portfolio.portfolioPages && this.portfolio.portfolioPages.length && this.currentPortfolioPage) {
				this.togglePortfolioPageExpanded(this.portfolio.portfolioPages.find(p => p.portfolioPageID === this.currentPortfolioPage));
		}
	}
	
	public setViewType = (viewType) =>{
		this.viewType = viewType;
		this.$location.search( 'view', this.viewType );
		this.observerService.notify('viewType', this.viewType)
		
		this.portfolioPageDraggable = this.viewType === 'edit';
		this.contentModuleDraggable = this.portfolioPageDraggable;
	}
	
	public toggleFeatured = () =>{
		
		if(this.portfolio.portfolioType_systemCode === 'ptFeatured'){
			
			this.portfolio.portfolioType = {
				systemCode: 'ptUser'
			};
			
			this.portfolioService.savePortfolio(this.portfolio).then(
				(response) => {
					if(response.data.success){
						this.portfolio.portfolioType_systemCode = 'ptUser';
					}
				}
			);
		} else {
			this.portfolioService.saveFeaturedPortfolio(this.portfolio).then(
				(response) => {
					if(response.successfulActions.length){
						this.portfolio.portfolioType_systemCode = 'ptFeatured';
					}
				}	
			);
		}
	}
	
	public toggleDisplaySideMenu = (clickOutside = true) =>{
		
		if(!clickOutside && this.displaySideMenu) return;
		
		this.displaySideMenu = !this.displaySideMenu;
	}
	
	public togglePortfolioPageExpanded = (portfolioPage) =>{
		portfolioPage.expanded = !portfolioPage.expanded;
		
		this.updatePortfolioPageExpanded(portfolioPage);
		
		if( portfolioPage.expanded && (
			!portfolioPage.contentModules ||
			!portfolioPage.contentModules.length)
		){ 
			this.portfolioService.getContentModulesForPortfolioPage(portfolioPage.portfolioPageID).then(
				(response:any) =>{
					portfolioPage.contentModules =  this.$filter('orderBy')(response.data, '+sortOrder');
				}
			);
		};
	}
	
	public togglePortfolioNameEdit = () => {
		this.portfolioNameEditMode = !this.portfolioNameEditMode;
		
		if(!this.portfolioNameEditMode && this.portfolio.title.length){
			this.savePortfolio();
		}
	}
	
	public togglePortfolioPageNameEdit = () =>{
		this.portfolioPageNameEditMode = !this.portfolioPageNameEditMode;
		
		if(!this.portfolioPageNameEditMode){
			this.savePortfolioPage();
		}
	}
	
	public updatePortfolioPageExpanded = (portfolioPage) =>{
		for(var i=0; i<this.portfolio.portfolioPages.length; i++){
			
			if(this.portfolio.portfolioPages[i].portfolioPageID === portfolioPage.portfolioPageID) continue; 
			
			this.portfolio.portfolioPages[i].expanded = false;
		}	 
	}
	
	private launchSaveAsModal(){
    	this.portfolioService.getMyPortfolioFolders({ showAll: true })
    	.then((result) => {
    		let allFolders = result.data.records;
    		this.ModalService.showModal({
    			component: 'saveAsModal',
    			bodyClass: 'angular-modal-service-active',
    			bindings: {
    				type: FolderTypes.Portfolio,
    				folders: allFolders,
    				portfolioPage: this.portfolioPage,
    				davisAccountType: this.davisAccountType,
    			},
    			preClose: (modal) => {
    				modal.element.modal('hide');
    			},
    		}).then((modal) => {
    			//it's a bootstrap element, use 'modal' to show it
    			modal.element.modal('show');
    			modal.close.then((result) => {});
    		});
    	});
	}
	
	private getPortfoliosInFolder = () => {
		if (this.portfolio && this.portfolio.folder && this.portfolio.folder.folderID) {
			this.siblingsLoading = true;
			this.portfolioService.getPortfoliosInFolder({ folderID: this.portfolio.folder.folderID })
			.then((result) => {
				this.siblingsLoading = false;
				this.siblingPortfolios = result.data.records.filter(p => p.portfolioID !== this.portfolio.portfolioID);
			});
		} else {
			this.siblingPortfolios = [];
		}
	}
	
	public onExport = () => {
		var anchor = document.createElement('a');
        anchor.href = '?slatAction=davisdigital:api.exportPortfolios&apiData.portfolioID=' + this.portfolio.portfolioID + '&apiData.downloadNowFlag=true';
        anchor.target = '_blank';
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
	}
	
	public onShare = () => {
	    this.listingModalService.launchShareSettingModal(this.portfolio.title,this.portfolio.portfolioID,'portfolio', "", null, { 
	    	sharedWithPublic: this.portfolio.sharedWithPublic,
	    	sharedWithDistrict: this.portfolio.sharedWithDistrict,
	    	urlTitle: this.portfolio.urlTitle || this.portfolio.title
	    });
	}
	
	public onCopyShareLink(): void {
		/* Get the text field */
		let input: HTMLInputElement = document.createElement('input');
		input.type = "text";
		input.className = 'hidden';
		input.value = `${window.location.origin}/${this.portfolio.urlTitle}`;
        document.body.appendChild(input);
		/* Select the text field */
		input.select();
		input.setSelectionRange(0, 99999); /* For mobile devices */
		
		/* Copy the text inside the text field */
		document.execCommand("copy");
        document.body.removeChild(input);
	}
	
	private initShepherdPortfolioEdit = (reset=false) => {
		
		let continueTour = this.setStorageKey("portfolioEditor");
		
		if(!continueTour && !reset){
				return;
		};
	
		let expandMobileMenu = false;
		
		if($(window).width() < 1320){
			expandMobileMenu = true;
		}
		// Creating Tour
		const tour = new Shepherd.Tour({
            defaultStepOptions: {
                keyboardNavigation: true,
                exitOnEsc: true,
	            cancelIcon: {
	                enabled: true
	            },
	            classes: 'custom-davis-tour custom-davis-tour-portfolio-edit',
                scrollTo: { 
                	behavior: 'smooth', block: 'center'		
                }
            },
            useModalOverlay: true
		});
		
		const addStep = (step: { id: string, title: string, text: string, attachTo: {element: string, on: string }, timeout ?: number}) => {
    		tour.addStep({
                id: step.id,
                title: step.title,
                text: step.text,
                attachTo: step.attachTo,
    		  
                buttons: [
                    {
                        action: tour.cancel,
                        classes: 'shepherd-button-stop-helper-temporarily',
                        text: 'Stop helper'
                    },
                    {
                        action: tour.complete,
                        classes: 'shepherd-button-stop-helper-forever',
                        text: 'Stop helper and don\'t show again'
                    },
                    {
                        action: tour.next,
                        classes: 'shepherd-button-next',
                        text: 'Next'
                    }
                ],
                beforeShowPromise: ()=>{
                	if(step.id == "step01" && expandMobileMenu){
                		$(".lesson_right").addClass("show");
                	}
                	if(step.id == "step04"){
                		 this.$rootScope.$apply(()=>{
								  this.displaySideMenu = true;
								  $(".lesson_right").removeClass("show");
                    	 });
                    }
                    if(step.id == "step06"){
                    	$(".lesson_right").addClass("show");
                    }
             

                    return new Promise((resolve)=>{
                    	setTimeout(()=>{
                    		resolve();
                    	}, step.timeout || 0);
                    });
                }
    		});
		};
		
		this.apiService.getTypesByParent('helperTextEditPortfolio')
			.then( data => {
			 	var elements = ['.shepherd-view','.shepherd-share','.shepherd-export','.shepherd-TOC','.shepherd-add-page'];
				for( let index = 0; index < data.length; index++){
				var position='top';
				if(index==2){
					position='rigth';
				}
				if(index==0 || index==3){
					
				 addStep({
							  id: "step0"+(index+1),
							  title: "0"+(index+1)+"/0"+data.length,
							  text:data[index].typeDescription,
							  attachTo: {
						    	element:elements[index],
						    	on: 'bottom'
								},
							  timeout: 800,
							});
					}else{
						 addStep({
							  id: "step0"+(index+1),
							  title: "0"+(index+1)+"/0"+data.length,
							  text:data[index].typeDescription,
							  attachTo: {
						    	element:elements[index],
						    	on: 'bottom'
								}
							});
					}
		
				}
			tour.start();
			tour.on('complete', function(){
	               $(".lesson_right").removeClass("show");
			} )
		 });

	}
	
//param: if tour is for a "new" item tour or "edit" item tour, will show helper so many times, returns false to exit helper
	private setStorageKey = (action : string ) => {
		
	//	let localStorageKey = action == "new" ? 'lesson_editor_new_tour_completed' : "lesson_editor_tour_completed";
	
		let localStorageKey = action;
		
		Shepherd.on('cancel', () => {
			if(!this.localStorageService.getItem(localStorageKey)){
				this.localStorageService.setItem(localStorageKey, '1');
			} else if (this.localStorageService.getItem(localStorageKey) == '1') {
				this.localStorageService.setItem(localStorageKey, '2')
			} else if (this.localStorageService.getItem(localStorageKey) == '2'){
				this.localStorageService.setItem(localStorageKey, '3')
			} else if (this.localStorageService.getItem(localStorageKey) == '3'){
				return false;
			}
		});
	    
	    if(this.localStorageService.getItem(localStorageKey)){
			let storageKey = this.localStorageService.getItem(localStorageKey);
			if( storageKey != '1' && storageKey != '2')
	        return false;
	    }
	    
	    Shepherd.on('complete', (context, args) => {
	    	//ignore complete action if done from last step, so user can see it again on reload
	    		this.localStorageService.setItem(localStorageKey, Date.now());
	    });
	
		//return true to continue shepherd init
		return true;
	}	    

	
}

export { PortfolioEditorController };
